import styled from 'styled-components';

export const CompletionHeader = styled.h2`
  font-size: 1.125rem !important;
`;
